// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1XpWM","question":"Question_question__20y0J","description":"Question_description__1Ifm1"};